import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { PageHeaderComponent } from './page-header/page-header.component';
import { StatTileComponent } from './stat-tile/stat-tile.component';
import { StatusBadgeComponent } from './status-badge/status-badge.component';
import { AvatarComponent } from './avatar/avatar.component';
import { EmptyStateComponent } from './empty-state/empty-state.component';
import { VwTooltipComponent } from './tooltip/vw-tooltip.component';
import { VwTooltipDirective } from './tooltip/vw-tooltip.directive';
import { TourOverlayComponent } from './tour/tour-overlay.component';
import { HelpPanelComponent } from './help-panel/help-panel.component';
import { GlobalSearchComponent } from './global-search/global-search.component';
import { LoginSceneComponent } from './login-scene/login-scene.component';
import { PaginationBarComponent } from './pagination-bar/pagination-bar.component';
import { LegalWheelComponent } from './legal-wheel/legal-wheel.component';
import { CountUpDirective } from './count-up.directive';
import { KeyboardShortcutsOverlayComponent } from './keyboard-shortcuts/keyboard-shortcuts-overlay.component';
import { ConnectionStatusComponent } from './connection-status/connection-status.component';
import { CommandPaletteComponent } from './command-palette/command-palette.component';
import { FileDropzoneDirective } from './file-dropzone.directive';
import { FieldValidityDirective } from './field-validity.directive';
import { DateRangePresetComponent } from './date-range-preset/date-range-preset.component';
import { CopyButtonComponent } from './copy-button/copy-button.component';
import { BulkActionsBarComponent } from './bulk-actions-bar/bulk-actions-bar.component';
import { SessionTimeoutModalComponent } from '../session-timeout/session-timeout-modal.component';
import { ChangeConfirmModalComponent } from './change-confirm/change-confirm-modal.component';
import { RecordDetailsModalComponent } from './record-details/record-details-modal.component';
import { SearchableSelectComponent } from './searchable-select/searchable-select.component';
import { GuestTypeLabelPipe } from './guest-type-label.pipe';
import { PhoneNumberHintDirective } from './phone-number-hint.directive';

@NgModule({
  imports: [CommonModule, RouterModule, FormsModule, NgxPaginationModule],
  declarations: [
    PageHeaderComponent,
    StatTileComponent,
    StatusBadgeComponent,
    AvatarComponent,
    EmptyStateComponent,
    VwTooltipComponent,
    VwTooltipDirective,
    TourOverlayComponent,
    HelpPanelComponent,
    GlobalSearchComponent,
    LoginSceneComponent,
    PaginationBarComponent,
    LegalWheelComponent,
    CountUpDirective,
    KeyboardShortcutsOverlayComponent,
    ConnectionStatusComponent,
    CommandPaletteComponent,
    FileDropzoneDirective,
    FieldValidityDirective,
    DateRangePresetComponent,
    CopyButtonComponent,
    BulkActionsBarComponent,
    SessionTimeoutModalComponent,
    ChangeConfirmModalComponent,
    RecordDetailsModalComponent,
    SearchableSelectComponent,
    GuestTypeLabelPipe,
    PhoneNumberHintDirective,
  ],
  exports: [
    PageHeaderComponent,
    StatTileComponent,
    StatusBadgeComponent,
    AvatarComponent,
    EmptyStateComponent,
    VwTooltipDirective,
    TourOverlayComponent,
    HelpPanelComponent,
    GlobalSearchComponent,
    LoginSceneComponent,
    PaginationBarComponent,
    LegalWheelComponent,
    CountUpDirective,
    KeyboardShortcutsOverlayComponent,
    ConnectionStatusComponent,
    CommandPaletteComponent,
    FileDropzoneDirective,
    FieldValidityDirective,
    DateRangePresetComponent,
    CopyButtonComponent,
    BulkActionsBarComponent,
    SessionTimeoutModalComponent,
    ChangeConfirmModalComponent,
    RecordDetailsModalComponent,
    SearchableSelectComponent,
    GuestTypeLabelPipe,
    PhoneNumberHintDirective,
  ],
  entryComponents: [VwTooltipComponent],
})
export class SharedUiModule {}
